import { createFileRoute } from '@tanstack/react-router';
import { StockComparisonPage } from '../../../pages/tools/market/StockComparisonPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/stock-comparison')({
  head: () => toolHead('stock-comparison'),
  component: StockComparisonPage,
});
